import { apiClient } from '../lib/api';
import { z } from 'zod';
import { ApiResponseSchema } from '../schemas';

export const FilterOptionSchema = z.object({
	value: z.string(),
	label: z.string(),
}).strip();

export const MajorFilterOptionSchema = FilterOptionSchema.extend({
	maKhoa: z.string().optional().default(''),
}).strip();

export const AllFiltersDataSchema = z.object({
	years: z.array(z.number()),
	faculties: z.array(FilterOptionSchema),
	majors: z.array(MajorFilterOptionSchema),
	provinces: z.array(FilterOptionSchema),
	mergedProvinces: z.array(FilterOptionSchema),
}).strip();

export const generalStatsApi = {
	getAvailableYears: async () => {
		const response = await apiClient.get('/stats/general/available-years');
		return ApiResponseSchema(z.array(z.number())).parse(response.data);
	},

	getAllFilters: async () => {
		const response = await apiClient.get('/stats/general/filters');
		return ApiResponseSchema(AllFiltersDataSchema).parse(response.data);
	},
};
